/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminFeatureFlagResponse } from '../models/AdminFeatureFlagResponse';
import type { AdminFeatureFlagsResponse } from '../models/AdminFeatureFlagsResponse';
import type { UpdateFeatureFlagDto } from '../models/UpdateFeatureFlagDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DashboardFeatureFlagsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List the feature flags
     * Every flag declared in code with its name, description and state in this environment.
     * @returns AdminFeatureFlagsResponse
     * @throws ApiError
     */
    public featureFlagsDashboardControllerGetAll(): CancelablePromise<AdminFeatureFlagsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/dashboard/feature-flags',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
            },
        });
    }
    /**
     * Turn a feature flag on or off
     * Changes the flag in this environment only.
     * @returns AdminFeatureFlagResponse
     * @throws ApiError
     */
    public featureFlagsDashboardControllerSetEnabled({
        key,
        requestBody,
    }: {
        /**
         * Flag key
         */
        key: string,
        requestBody: UpdateFeatureFlagDto,
    }): CancelablePromise<AdminFeatureFlagResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/dashboard/feature-flags/{key}',
            path: {
                'key': key,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
                404: `Unknown flag.`,
            },
        });
    }
}
